import type { TicketsItem } from '@/api/server/detail/dto/detailDto'
import { Caption } from '@/shared/components/typography'

interface SummaryCommentSectionViewProps {
  isPartner: boolean
  tickets: TicketsItem[]
  moduComment?: string
}

const SummaryCommentSectionView = ({ moduComment, isPartner, tickets }: SummaryCommentSectionViewProps) => {
  if (isPartner && moduComment)
    return (
      <div className="mx-[16px] mt-[16px] flex items-center justify-center rounded-md bg-notice-050 px-[31px] py-[9px]">
        <Caption level="caption2" weight="regular" color="text090" className="w-full text-center">
          {moduComment}
        </Caption>
      </div>
    )
  if (!isPartner || tickets.length === 0)
    return (
      <div className="mx-[16px] mt-[16px] flex items-center justify-center rounded-md bg-020 px-[31px] py-[9px]">
        <Caption level="caption2" weight="regular" color="text070" className="w-full text-center">
          아직 주차권을 판매하지 않는 현장입니다.
        </Caption>
      </div>
    )
  else return <></>
}

export default SummaryCommentSectionView
